module.exports = __webpack_public_path__ + "media/img/android-icon-72x72-9b9d336f5fe2d766e20267a1b40865c8.png";